import { render, staticRenderFns } from "./Detail-Contract.vue?vue&type=template&id=2a3b2d6a"
import script from "./Detail-Contract.vue?vue&type=script&lang=js"
export * from "./Detail-Contract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports